import { render, staticRenderFns } from "./MoreMenuStats.vue?vue&type=template&id=7bcb7908&scoped=true&"
import script from "./MoreMenuStats.vue?vue&type=script&lang=ts&"
export * from "./MoreMenuStats.vue?vue&type=script&lang=ts&"
import style0 from "./MoreMenuStats.vue?vue&type=style&index=0&id=7bcb7908&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bcb7908",
  null
  
)

export default component.exports